var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.computedClass},[_c('v-btn',{attrs:{"elevation":"2","href":_vm.generateLinkDownload(_vm.value)}},[_vm._v("\n  "+_vm._s(this.$i18n.t('fatura'))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }